export const formatPoNumber = (prefix: string, poNumber: string): string =>
  `${prefix}${poNumber}`;

export const removePoPrefix = (prefix: string, poNumber: string): string =>
  poNumber?.replace(prefix, "");
